import { dataEpics } from './data/data.epics';
import { declineEpics } from './decline/decline.epics';
import { thanksEpics } from './thanks/thanks.epics';
import { meetingEpics } from './meeting/meeting.epics';
import { bookedMeetingInfoEpics } from './bookedMeetingInfo/bookedMeetingInfo.epics';
import { finishInfoEpics } from './finishInfo/finishInfo.epics';
import { statusesEpics } from './statuses/statuses.epics';
import { actionsEpics } from './requiredActions/requiredActions.epics';
import { shippingEpics } from './shipping/shipping.epics';
import { claimEpics } from './claim/claim.epics';
import { addressEpics } from './address';

export default [
  ...dataEpics,
  ...declineEpics,
  ...thanksEpics,
  ...meetingEpics,
  ...bookedMeetingInfoEpics,
  ...finishInfoEpics,
  ...statusesEpics,
  ...actionsEpics,
  ...shippingEpics,
  ...claimEpics,
  ...addressEpics,
];
